.block {
  width: 100%;
}

.flex {
  display: flex;
}
.flex.row {
  flex-direction: row;
}
.flex.column {
  flex-direction: column;
}
.flex.wrap {
  flex-wrap: wrap;
}
.flex.nowrap {
  flex-wrap: nowrap;
}
.flex.j-items-normal {
  justify-items: normal;
}
.flex.j-items-center {
  justify-items: center;
}
.flex.j-items-start {
  justify-items: start;
}
.flex.j-items-end {
  justify-items: end;
}
.flex.j-items-stretch {
  justify-items: stretch;
}
.flex.j-content-normal {
  justify-content: normal;
}
.flex.j-content-center {
  justify-content: center;
}
.flex.j-content-start {
  justify-content: start;
}
.flex.j-content-end {
  justify-content: end;
}
.flex.j-content-space-between {
  justify-content: space-between;
}
.flex.j-content-space-around {
  justify-content: space-around;
}
.flex.j-content-space-evenly {
  justify-content: space-evenly;
}
.flex.a-items-normal {
  align-items: normal;
}
.flex.a-items-center {
  align-items: center;
}
.flex.a-items-start {
  align-items: start;
}
.flex.a-items-end {
  align-items: end;
}
.flex.a-items-stretch {
  align-items: stretch;
}
.flex.a-items-baseline {
  align-items: baseline;
}
.flex.a-content-normal {
  align-content: normal;
}
.flex.a-content-center {
  align-content: center;
}
.flex.a-content-start {
  align-content: start;
}
.flex.a-content-end {
  align-content: end;
}
.flex.a-content-space-around {
  align-content: space-around;
}
.flex.a-content-space-between {
  align-content: space-between;
}
.flex.a-content-stretch {
  align-content: stretch;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */